const axios = require('axios');
module.exports.init = me => {
  me.getTeachers = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/teachers`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getProvince = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/areas/provinces`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
};